import { EtapeCreationDossier } from '../services/generated/FrontOffice-api';

// Note: sera probablement renvoyé par l'api quand il y aura les steps dynamiques
export enum EtapeCreationPlus {
    ValidationStructure2 = "ValidationStructure2"
};

export type CreationDossierSteps = EtapeCreationDossier | EtapeCreationPlus;
